import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import DataTable from "../../lib/DataTable";
import { Notice } from "../../lib/ui";

/* Products expiring within 30 days – port of stockexpiry.php (API: GET /api/stock/expiring) */

export default function StockExpiry() {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/stock/expiring").then(setRows).catch((e) => setError(e.message)); }, [api]);
  const tone = (d) => (d <= 7 ? "err" : d <= 14 ? "warn" : "");
  const columns = [
    { key: "product_id", label: "ID", num: true },
    { key: "product_name", label: "Name", render: (r) => <b style={{ color: "var(--ink)" }}>{r.product_name}</b> },
    { key: "manufacturer", label: "Manufacturer" }, { key: "product_type", label: "Type" },
    { key: "expiry_date", label: "Expiry date" },
    { key: "remaining_days", label: "Remaining", num: true, render: (r) => <span className={`pill-tag ${tone(r.remaining_days)}`}>{r.remaining_days} day{r.remaining_days === 1 ? "" : "s"}</span> },
    { key: "purchase_price", label: "Purchase", num: true, render: (r) => n2(r.purchase_price) },
    { key: "retail_price", label: "Retail", num: true, render: (r) => n2(r.retail_price) },
    { key: "wholesale_price", label: "Wholesale", num: true, render: (r) => n2(r.wholesale_price) },
    { key: "retail_unit", label: "Retail unit" }, { key: "wholesale_unit", label: "Wholesale unit" },
    { key: "wholesale_pack_size", label: "Pack size", num: true },
    { key: "minimum_stock", label: "Min stock", num: true }, { key: "quantity", label: "Quantity", num: true },
  ];
  return (
    <main className="pg" style={{ maxWidth: "100rem" }}>
      <PageHeader slug="stockexpiry" actions={<Link to="/addStock" className="btn"><i className="fas fa-list" /> View all products</Link>} />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel">
        {rows ? <DataTable columns={columns} rows={rows} rowKey={(r) => r.product_id} searchPlaceholder="Search expiring products"
          initialSort={{ key: "expiry_date", dir: 1 }} empty="No products expire in the next 30 days." />
          : <div className="empty"><i className="fas fa-spinner fa-spin" />Loading…</div>}
      </section>
    </main>
  );
}
